<template>
  <div style="overflow-x:hidden;">
    <loading-screen
      v-bind:p_configuratorName="p_configuratorName"
      v-bind:p_logoUrl="p_logoUrl"
      v-bind:p_randomFacts="p_randomFacts"
    />
    <div
      v-show="isConfiguratorLoaded"
      class="configurator-wrapper"
      id="configurator"
    >
      <div id="configuratorNavigation">
        <topbar
          ref="topbar"
          v-bind:p_showPGSwitch="showPGButton"
          v-bind:p_showSkip="showSkipButton"
          v-bind:p_steps="steps"
          v-bind:p_isSkipDisabled="isSkipDisabled"
          v-bind:p_showHelp="showHelp"
          v-bind:p_priceText="priceText"
          v-bind:p_isLeftButtonDisabled="isLeftButtonDisabled"
          v-bind:p_isRightButtonDisabled="isRightButtonDisabled"
          v-bind:p_isPriceOnRequest="isPriceOnRequest"
          v-bind:p_isPriceCalculating="
            isPriceRuleCheckCompleted && isRuleCheckCompleted
          "
        />
        <button
          class="configuratorStepBar-toggle-button stepBar-button-is-hidden"
          title="Übersicht der Konfigurations-Schritte"
        >
          <i class="fal fa-list-ul"></i>
        </button>
        <stepbar
          ref="stepbar"
          v-bind:p_steps="steps"
          v-bind:p_showOverview="showOverview"
          v-bind:p_isOverviewStepVisible="isOverviewStepVisible"
          v-bind:p_isOverviewStepAccessible="isOverviewStepAccessible"
        />
        <popup
          v-bind:p_isWarning="true"
          p_text="Wenn sie Optionen in vorherigen Schritten ändern, können die Eingaben in den folgenden Schritten zurückgesetzt werden."
          p_header="Information"
          v-bind:p_isVisible="isWarningPopupVisible"
        />
        <popup
          v-bind:p_isWarning="true"
          p_text="Wählen Sie einen Wert für jedes Dropdown-Menü bevor Sie eine der Abtrennungen auswählen."
          p_header="Information"
          v-bind:p_isExecutedOnceIgnored="true"
          v-bind:p_isVisible="isEnclosurePopupVisible"
        />
        <popup
          v-bind:p_isInfo="true"
          v-bind:p_isExecutedOnceIgnored="true"
          p_text="Diese Option ist in der Demo noch nicht verfügbar."
          p_header="Demo-Version"
          v-bind:p_isVisible="isInfoPopupVisible"
        />
        <popup
          v-bind:p_isInfo="true"
          v-bind:p_isExecutedOnceIgnored="true"
          p_text="Es ist nicht möglich diesen Schritt zu überspringen."
          p_header="Schritt nicht überspringbar"
          v-bind:p_isVisible="isSkipInfoPopupVisible"
        />
        <popup
          v-bind:p_isLoadingPopup="true"
          v-bind:p_isExecutedOnceIgnored="true"
          p_text=""
          v-bind:p_isVisible="isLoadingPopupVisible"
        />
        <shower-popup v-bind:p_isShowerPopupVisible="isShowerPopupVisible" />
      </div>
      <div class="" v-bind:class="stepWrapperClass">
        <template v-for="(step, index) in steps">
          <step
            v-bind:key="index"
            v-bind:p_index="index"
            ref="stepListItems"
            v-bind:p_skippableAttributeId="step.skippableAttributeId"
            v-bind:p_skippableAttributeName="step.skippableAttributeName"
            v-bind:p_stepType="step.stepType"
            v-bind:p_customId="step.customId"
            v-bind:p_isSkippable="step.isSkippable"
            v-bind:p_stepId="step.id"
            v-bind:p_headline="step.description"
            v-bind:p_isVisible="step.isVisible"
            v-bind:p_configuratorDomain="p_configuratorDomain"
          />
        </template>
        <overview
          ref="overview"
          :p_configuratorDomain="p_configuratorDomain"
          v-bind:p_steps="steps"
          v-bind:p_overviewSettings="overviewSettings"
          v-bind:p_price="priceText"
          v-bind:p_showOverviewPrint="showOverviewPrint"
          v-bind:p_showOverviewRestart="showOverviewRestart"
          v-bind:p_showAdvisory="showHelp"
          v-if="isOverviewStepVisible"
          v-bind:p_isPriceOnRequest="isPriceOnRequest"
        />
      </div>
      <help v-if="isHelpVisible" v-bind:p_helpSettings="helpSettings" />
      <load-save
        ref="loadSave"
        v-show="isLoadSaveVisible"
        v-bind:p_isConfigurationNameRequired="isConfigurationNameRequired"
        v-bind:p_steps="steps"
        v-bind:p_configuratorId="p_configuratorId"
        v-bind:p_isOverviewStepAccessible="isOverviewStepAccessible"
        v-bind:p_price="priceText"
      />
    </div>
    <component ref="mainComponent" v-bind:is="mainComponent"></component>
  </div>
</template>

<script>
import axios from "axios";
import Topbar from "./Topbar";
import LoadingScreen from "./LoadingScreen";
import Step from "./Step";
import Stepbar from "./Stepbar";
import Help from "./Help";
import LoadSave from "./LoadSave";
import Overview from "./Overview";
import Popup from "./Popup";
import ShowerPopup from "../customer/duschking-konfigurator/ShowerPopup";

const urlConfigurationStepsRest =
  process.env.URL_BACKEND +
  process.env.REST_CONFIGURATOR_GET_CONFIGURATOR_STEPS;
const urlPriceRuleReadAllFromStepRest =
  process.env.URL_BACKEND + process.env.REST_PRICE_RULE_READ_ALL_FROM_STEP;
const urlValidateRuleRest =
  process.env.URL_BACKEND + process.env.REST_RULE_VALIDATE_RULE;
const stepWrapperToggleClass = "configurator-step-wrapper-bar-on";

export default {
  components: {
    LoadingScreen,
    Step,
    Topbar,
    Stepbar,
    Popup,
    Help,
    ShowerPopup,
    LoadSave,
    Overview
  },
  props: {
    p_configuratorSettings: [],
    p_configuratorId: Number,
    p_configuratorName: String,
    p_configuratorDomain: String,
    p_logoUrl: String,
    p_randomFacts: String
  },
  data() {
    return {
      isConfiguratorLoaded: false,
      isConfigurationNameRequired: false,
      isLeftButtonDisabled: true,
      isRightButtonDisabled: true,
      isWarningPopupVisible: false,
      isEnclosurePopupVisible: false,
      isLoadingPopupVisible: false,
      isInfoPopupVisible: false,
      isSkipInfoPopupVisible: false,
      isShowerPopupVisible: false,
      isOverviewStepVisible: false,
      isOverviewStepAccessible: false,
      isGetConfiguratorCodeGiven: false,
      isGetConfiguratorLoading: false,
      steps: [],
      getConfiguratorCode: "",
      stepWrapperClass: "",
      actualStep: 0,
      priceText: "Kein Basispreis gewählt",
      basePriceFloat: -1.0,
      basePriceSettingFloat: -1.0,
      priceFloat: -1.0,
      isStepAxiosReady: false,
      isSelectionCardAxiosReady: false,
      isHelpVisible: false,
      isLoadSaveVisible: false,
      showHelp: false,
      showOverview: false,
      showOverviewPrint: false,
      showSkipButton: false,
      showPGButton: false,
      showOverviewRestart: true,
      helpSettings: [],
      overviewSettings: [],
      stepsReady: [],
      allStepsReady: false,
      isSkipDisabled: true,
      isSkipStepExecuted: false,
      isRuleCheckCompleted: false,
      isPriceRuleCheckCompleted: true,
      timerRuleCheck: null,
      timerRuleCheckLoading: null,
      productPricesSum: 0,
      mainComponent: null,
      isPriceOnRequest: false,
      allowOverwriting: true,
      singlePrices: [],
      singleQuantityPrices: []
    };
  },
  computed: {
    c_currency() {
      return new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR"
      }).format(this.roundToTwo(this.priceFloat + this.productPricesSum));
    },
    c_basePriceCurrency() {
      return new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR"
      }).format(this.roundToTwo(this.basePriceFloat));
    },
    c_customCSS() {
      return "../../scss/customer/" + this.p_configuratorDomain + "/style.css";
    }
  },
  methods: {
    checkRuleCompletedBeforeNextStep() {
      this.isLoadingPopupVisible = true;
      this.setRuleCheckCompleted(false);
      this.setPriceRuleCheckCompleted(false);
      this.updateNextStep();
      this.timerRuleCheck = setInterval(() => {
        if (this.isRuleCheckCompleted && this.isPriceRuleCheckCompleted) {
          this.showNextStep();
          this.setNextStepToAccessible();
          clearInterval(this.timerRuleCheck);
          this.timerRuleCheck = null;
          this.timerRuleCheckLoading = setInterval(() => {
            clearInterval(this.timerRuleCheckLoading);
            this.timerRuleCheckLoading = null;
            this.isLoadingPopupVisible = false;
          }, 500);
        }
      }, 1000);
    },
    setLoadingPopupManually(isLoadingPopupVisible) {
      this.isLoadingPopupVisible = isLoadingPopupVisible;
    },
    setRuleCheckCompleted(completed) {
      this.isRuleCheckCompleted = completed;
    },
    setPriceRuleCheckCompleted(completed) {
      this.isPriceRuleCheckCompleted = completed;
    },
    setAllowOverwriting(booleanValue) {
      this.allowOverwriting = booleanValue;
    },
    setIsLoadSaveVisible(booleanValue) {
      this.isLoadSaveVisible = booleanValue;
    },
    setIsGetConfiguratorLoading(booleanValue) {
      this.isGetConfiguratorLoading = booleanValue;
    },
    checkSkipEnabled() {
      if (this.isOverviewStepVisible) {
        this.isSkipDisabled = true;
      } else {
        this.isSkipDisabled = !this.$refs.stepListItems[this.actualStep]
          .p_isSkippable;
      }
    },
    checkConfiguratorReady() {
      let configuratorReady = false;
      if (
        this.isStepAxiosReady &&
        this.isSelectionCardAxiosReady &&
        this.allStepsReady
      ) {
        if (this.isGetConfiguratorCodeGiven && !this.isGetConfiguratorLoading) {
          configuratorReady = true;
          if (this.getConfiguratorCode.length > 0) {
            this.isGetConfiguratorLoading = true;
            this.$refs.loadSave.loadConfiguration(this.getConfiguratorCode);
            this.isLoadSaveVisible = true;
          }
        } else {
          configuratorReady = true;
        }
      }
      return configuratorReady;
    },
    clearSteps() {
      this.steps.forEach(step => {
        step.isVisible = false;
        step.isAccessible = false;
      });
      // step 1 is always accessible
      this.steps[0].isAccessible = true;
      this.$refs.stepListItems.forEach(refStep => {
        refStep.resetTicks();
        refStep.resetDropdowns();
      });
      this.isOverviewStepVisible = false;
      this.isOverviewStepAccessible = false;
    },
    setHelpVisibility(booleanValue) {
      this.isHelpVisible = booleanValue;
    },
    setLoadSaveVisibility(booleanValue) {
      this.isLoadSaveVisible = booleanValue;
    },
    sendShoppingCartEmail(shoppingCartEmail) {
      this.$refs.loadSave.sendConfigurationCodeMail(shoppingCartEmail);
    },
    setStepAxiosReady(booleanValue) {
      this.isStepAxiosReady = booleanValue;
    },
    setSelectionCardAxiosReady(booleanValue) {
      this.isSelectionCardAxiosReady = booleanValue;
    },
    setConfiguratorLoaded() {
      this.isConfiguratorLoaded = true;
    },
    getAllSteps() {
      // Call REST getconfiguratorsteps
      const json = JSON.stringify({
        configurator: { id: this.p_configuratorId }
      });
      axios
        .post(urlConfigurationStepsRest, json, {
          headers: {
            // Overwrite Axios's automatically set Content-Type
            "Content-Type": "application/json"
          }
        })
        .then(result => {
          let tmpIndex = 0;
          result.data.forEach(element => {
            this.steps.push({
              id: element.id,
              index: tmpIndex,
              customId: element.name
                .replace(/ /g, "_")
                .replace(/-/g, "_")
                .toLowerCase(),
              name: element.name,
              description: element.description,
              faIcon: element.fa_icon,
              isSkippable: element.is_skippable == 0 ? false : true,
              skippableAttributeId: element.skippable_attribute_id,
              skippableAttributeName: element.skippable_attribute_name,
              isAffectingFollowingSteps:
                element.is_affecting_following_steps == 0 ? false : true,
              ruleId: element.rule_id,
              stepType: element.step_type,
              isVisible: false,
              isAccessible: false,
              isHidden: false
            });
            this.stepsReady.push(false);
            // The first step is visible by default
            this.steps[0].isVisible = true;
            // The first step is also accessible by default
            this.steps[0].isAccessible = true;
            tmpIndex = tmpIndex + 1;
          });
        })
        .finally(() => {
          this.checkIfStepIsHidden();
          this.isStepAxiosReady = true;
        });
    },
    async loadConfigurationFromVuex() {
      // This method is executed, when in the configurator save / load modal
      // the load configurator is clicked
      this.clearSteps();
      // Get the last step and set the ticks in every step and check rules for Steps
      let lastStepIndex = -1;
      // If Overviewpage is accessible the overview is shown after load
      let overviewPageAccessible = false;
      this.$store.state.stepValues.forEach(stepValue => {
        // -1 is saved, when overviewPage has been arrived
        if (stepValue.stepIndex == -1) {
          overviewPageAccessible = true;
        } else {
          // set all stored steps to accessible
          let stepIndex = -1;
          for (let i = 0; i < this.steps.length; ++i) {
            if (stepValue.stepId == this.steps[i].id) {
              stepIndex = i;
            }
          }
          if (stepIndex >= 0) {
            this.steps[stepIndex].isAccessible = true;
            // check the rules for every stored step
            this.$refs.stepListItems[stepIndex].checkRules();
            // If the step is a selectioncardstep
            if (stepValue.selectionCardId != null) {
              // set button tick on the saved selection card
              this.$refs.stepListItems[stepIndex].setTick(
                stepValue.selectionCardId
              );
              if (stepValue.dropdownId >= 0) {
                this.$refs.stepListItems[stepIndex].setDropdown(
                  stepValue.selectionCardId,
                  stepValue.dropdownId
                );
              }
              this.$refs.stepListItems[stepIndex].setInputs();
            }
            if (stepIndex > lastStepIndex) {
              lastStepIndex = stepIndex;
            }
          }
        }
      });
      // Set all steps until lastStep to accessible (skipped steps included)
      for (let i = 0; i < lastStepIndex; i++) {
        this.steps[i].isAccessible = true;
      }
      lastStepIndex = lastStepIndex == -1 ? 0 : lastStepIndex;
      this.actualStep = lastStepIndex;
      // The case when the overview is accessible
      // => Set the oveviewpage to visible and the progressbar to full progressbar
      if (overviewPageAccessible) {
        this.isOverviewStepVisible = true;
        this.isOverviewStepAccessible = true;
        this.$refs.topbar.updateProgressBar(-1);
        if (this.$refs.overview != undefined) {
          this.$refs.overview.changeBackgroundImage(true);
        }
      } else {
        this.steps[lastStepIndex].isVisible = true;
        this.$refs.topbar.updateProgressBar(this.steps[this.actualStep].id);
      }
      this.checkIfStepIsHidden();
      this.checkPrice();
      this.updateStepButtons();
      this.checkSkipEnabled();
      // Check ProductPrices this method is in all steps, but it doesn't mind
      // in which step this is executed.
      let priceCheck = await this.$refs.stepListItems[0].checkProductPrices();

      if (priceCheck == 0) {
        this.setProductPricesSum(0);
      } else {
        this.singlePrices = priceCheck.data.single_prices;
        this.singleQuantityPrices = priceCheck.data.single_quantity_prices;
        this.setProductPricesSum(priceCheck.data.determined_price_sum);
      }
    },
    checkIfStepIsHidden() {
      // Get the last accessible Step index.
      // This is used for the visibility rule
      // e.g Step 2 is changed and Step 5 is visible after the change
      let lastAccessibleStepIndex = -1;
      for (let i = 0; i < this.steps.length; ++i) {
        if (this.steps[i].isAccessible) {
          lastAccessibleStepIndex = i;
        }
      }
      let hiddenAxios = [];
      let axiosStepIndices = [];
      for (let i = 0; i < this.steps.length; ++i) {
        if (this.steps[i].ruleId != null) {
          let json = {
            rule: {},
            validationValues: {}
          };
          json.rule.id = this.steps[i].ruleId;
          this.$store.state.stepValues.forEach(stepValue => {
            if (stepValue.attributeId >= 0) {
              json.validationValues[stepValue.attributeName] = stepValue.value;
            }
          });
          json = JSON.stringify(json);
          // Call REST validaterule
          axiosStepIndices.push(i);
          hiddenAxios.push(
            axios({
              method: "post",
              url: urlValidateRuleRest,
              data: json,
              headers: {
                "Content-Type": "application/json"
              }
            })
          );
        }
      }
      if (hiddenAxios.length > 0) {
        axios
          .all(hiddenAxios)
          .then(
            axios.spread((...responses) => {
              // if (!firstResponseExecuted) {
              //   for (let i = 0; i < hiddenAxios.length; ++i) {
              //     this.steps[axiosStepIndices[i]].isHidden = false;
              //   }
              //   firstResponseExecuted = true;
              // }
              // let affectedIndizes = [];
              for (let i = 0; i < hiddenAxios.length; ++i) {
                this.steps[axiosStepIndices[i]].isHidden = responses[i].data;
                // if (affectedIndizes.some(e => e !== axiosStepIndices[i])) {
                //   affectedIndizes.push(axiosStepIndices[i]);
                // }
              }
              // affectedIndizes.forEach(element => {
              //   this.steps[element].isHidden = !this.steps[element].isHidden;
              // });
            })
          )
          .finally(() => {
            let lastAccessibleStepIndex = -1;
            // Get the last accessible step index
            for (let i = 0; i < this.steps.length; ++i) {
              if (this.steps[i].isAccessible) {
                lastAccessibleStepIndex = i;
              }
            }
            // Set the other steps to accessible if
            // the last accessible step is not reached or
            // the overviestep is accessible
            for (let i = 0; i < this.steps.length; ++i) {
              if (
                this.isOverviewStepAccessible ||
                i < lastAccessibleStepIndex
              ) {
                this.steps[i].isAccessible = true;
              }
            }
            // If Skip step is executed the execution of gotoNextStep
            // takes as long as the axios aren't ready
            this.setRuleCheckCompleted(true);
          });
      }
    },
    checkPrice() {
      // Is executed after the Vuex has changed
      let readPriceRuleAxios = [];
      // First Read all PriceRules out of the database till the last accessible step
      for (let i = 0; i < this.steps.length; ++i) {
        if (this.steps[i].isAccessible) {
          let json = {
            step: {},
            configurator: {}
          };
          json.step.id = this.steps[i].id;
          json.configurator.id = this.p_configuratorId;
          json = JSON.stringify(json);
          // Call REST readallPriceRulesFrom step
          readPriceRuleAxios.push(
            axios({
              method: "post",
              url: urlPriceRuleReadAllFromStepRest,
              data: json,
              headers: {
                "Content-Type": "application/json"
              }
            })
          );
        }
      }
      // Check all priceRules
      if (readPriceRuleAxios.length > 0) {
        axios.all(readPriceRuleAxios).then(
          axios.spread((...responses) => {
            let priceRuleElements = [];
            let checkPriceRuleAxios = [];
            for (let i = 0; i < responses.length; ++i) {
              if (responses[i].data.length > 0) {
                responses[i].data.forEach(element => {
                  let priceRuleElement = {};
                  let json = {
                    rule: {},
                    validationValues: {}
                  };
                  json.rule.id = element.rule_id;
                  this.$store.state.stepValues.forEach(stepValue => {
                    json.validationValues[stepValue.attributeName] =
                      stepValue.value;
                  });
                  priceRuleElement.ruleId = element.rule_id;
                  priceRuleElement.type = element.type;
                  priceRuleElement.value = element.value;
                  // Call REST validaterule
                  checkPriceRuleAxios.push(
                    axios({
                      method: "post",
                      url: urlValidateRuleRest,
                      data: json,
                      headers: {
                        "Content-Type": "application/json"
                      }
                    })
                  );
                  priceRuleElements.push(priceRuleElement);
                });
              }
            }
            // response from the price rules
            axios
              .all(checkPriceRuleAxios)
              .then(
                axios.spread((...responses) => {
                  let tmpPriceFloat = 0.0;
                  // First set the baseprice
                  for (let i = 0; i < responses.length; ++i) {
                    if (responses[i].data == true) {
                      if (priceRuleElements[i].type == "baseprice") {
                        this.basePriceFloat = priceRuleElements[i].value;
                        // tmpPriceFloat = this.basePriceFloat;
                      }
                    }
                  }
                  for (let i = 0; i < responses.length; ++i) {
                    if (responses[i].data == true) {
                      if (priceRuleElements[i].type == "absolute") {
                        tmpPriceFloat += priceRuleElements[i].value;
                      } else if (priceRuleElements[i].type == "relative") {
                        tmpPriceFloat *= priceRuleElements[i].value;
                      }
                    }
                  }
                  this.priceFloat = tmpPriceFloat;
                })
              )
              .finally(() => {
                this.refreshPrice();
                this.setPriceRuleCheckCompleted(true);
                this.$refs.mainComponent.calledMethodsAfterPriceChecked(this);
              });
          })
        );
      } else {
        this.refreshPrice();
        this.setPriceRuleCheckCompleted(true);
        this.$refs.mainComponent.calledMethodsAfterPriceChecked(this);
      }
    },
    setProductPricesSum(productPricesSum) {
      this.productPricesSum = productPricesSum;
      this.refreshPrice();
    },
    skipStep() {
      // The topbar component is executing this method,
      // when the skip button is clicked
      this.$refs.stepListItems[this.actualStep].resetTicks();
      this.$refs.stepListItems[this.actualStep].deleteStepValue();
      // Add skipped Value
      // TODO: Change hard coded Attribute ID
      this.$store.commit("addStepValue", {
        stepId: this.steps[this.actualStep].id,
        attributeId: this.steps[this.actualStep].skippableAttributeId,
        attributeName: this.steps[this.actualStep].skippableAttributeName,
        attributeVisible: 1,
        valueName: "Übersprungen",
        value: this.steps[this.actualStep].id
      });
      this.checkIfStepIsHidden();
      this.checkPrice();
      this.checkRuleCompletedBeforeNextStep();
    },
    showStepBarMobile() {
      this.$refs.stepbar.showStepBar();
    },
    hideStepBarMobile() {
      this.$refs.stepbar.hideStepBar();
    },
    showStepBar() {
      this.stepWrapperClass = stepWrapperToggleClass;
    },
    hideStepBar() {
      this.stepWrapperClass = "";
      $("#doorconfiguratorMobileBackgroundOverlay").fadeOut(600);
    },
    showWarningPopup() {
      this.isWarningPopupVisible = true;
    },
    showEnclosurePopup() {
      this.isEnclosurePopupVisible = true;
    },
    showInfoPopup() {
      this.isInfoPopupVisible = true;
    },
    showSkipInfoPopup() {
      this.isSkipInfoPopupVisible = true;
    },
    showShowerPopup() {
      this.isShowerPopupVisible = true;
    },
    hidePopup() {
      this.isWarningPopupVisible = false;
      this.isInfoPopupVisible = false;
      this.isSkipInfoPopupVisible = false;
      this.isShowerPopupVisible = false;
      this.isEnclosurePopupVisible = false;
    },
    setStepReady(index) {
      // The step calls this method
      // when it is ready
      this.stepsReady[index] = true;
      let allStepsReady = true;
      this.stepsReady.forEach(element => {
        if (!element) {
          allStepsReady = false;
        }
      });
      this.allStepsReady = allStepsReady;
    },
    updateNextStep() {
      // Set the last step to invisible
      let tmpActualStep = -1;
      if (this.showOverview && this.actualStep + 1 >= this.steps.length) {
        this.$refs.stepListItems[0].checkRules();
      } else {
        tmpActualStep = this.actualStep + 1;
        this.$refs.stepListItems[tmpActualStep].initializeStep();
        this.$refs.stepListItems[tmpActualStep].checkRules();
      }
    },
    refreshProducts() {
      this.$refs.stepListItems[0].refreshProducts();
    },
    showNextStep() {
      // Set the last step to invisible
      this.steps[this.actualStep].isVisible = false;
      let tmpStep = this.actualStep;
      let lastActualStep = this.actualStep;
      if (this.showOverview && tmpStep + 1 >= this.steps.length) {
        this.isOverviewStepAccessible = true;
        this.isOverviewStepVisible = true;
      } else {
        while (tmpStep + 1 < this.steps.length) {
          tmpStep += 1;
          if (!this.steps[tmpStep].isHidden) {
            this.actualStep = tmpStep;
            break;
          }
        }
        // If the last step is equal the actual step
        // the next steps are invisible and the
        // overview step is shown
        if (lastActualStep == this.actualStep) {
          this.isOverviewStepAccessible = true;
          this.isOverviewStepVisible = true;
        } else {
          // Set the new step to visible
          this.steps[this.actualStep].isVisible = true;
        }
      }
      // Update the status of the buttons (disabled or enabled)
      this.updateStepButtons();
      this.$refs.topbar.updateProgressBar(this.steps[this.actualStep].id);
      if (this.isOverviewStepVisible) {
        this.$refs.topbar.updateProgressBar(-1);
      }
      this.$refs.stepListItems[this.actualStep].initializeStep();
      this.$refs.stepListItems[this.actualStep].checkRules();
      this.checkSkipEnabled();
    },
    showPrevStep() {
      this.showWarningPopup();
      // Go to the last visible step, if
      // the actual step is the overview step
      if (this.isOverviewStepVisible) {
        this.isOverviewStepVisible = false;
        let tmpStep = this.steps.length;
        while (tmpStep - 1 >= 0) {
          tmpStep -= 1;
          if (!this.steps[tmpStep].isHidden) {
            this.actualStep = tmpStep;
            break;
          }
        }
      } else {
        this.steps[this.actualStep].isVisible = false;
        let tmpStep = this.actualStep;
        while (tmpStep - 1 >= 0) {
          tmpStep -= 1;
          if (!this.steps[tmpStep].isHidden) {
            this.actualStep = tmpStep;
            break;
          }
        }
      }
      // Set the new step to visible
      this.steps[this.actualStep].isVisible = true;
      // Update the status of the buttons (disabled or enabled)
      this.updateStepButtons();
      this.$refs.topbar.updateProgressBar(this.steps[this.actualStep].id);
      this.checkSkipEnabled();
    },
    showSpecificStep(stepIndex) {
      // Only show the warning popup if the specific step is below the actual
      if (stepIndex < this.actualStep) this.showWarningPopup();
      this.isOverviewStepVisible = false;
      // Set the last step to invisible
      this.steps[this.actualStep].isVisible = false;
      this.actualStep = stepIndex;
      // Set the specific step to visible
      this.steps[this.actualStep].isVisible = true;
      // Update the status of the buttons (disabled or enabled)
      this.updateStepButtons(true);
      this.$refs.topbar.updateProgressBar(this.steps[this.actualStep].id);
      this.checkSkipEnabled();
    },
    showOverviewStep() {
      // Set the last step to invisible
      this.steps[this.actualStep].isVisible = false;
      let tmpStep = this.steps.length;
      while (tmpStep - 1 >= 0) {
        tmpStep -= 1;
        if (!this.steps[tmpStep].isHidden) {
          this.actualStep = tmpStep;
          break;
        }
      }
      // Update the status of the buttons (disabled or enabled)
      this.isOverviewStepVisible = true;
      this.updateStepButtons();
      this.$refs.topbar.updateProgressBar(-1);
      this.checkSkipEnabled();
    },
    setNextStepsToNotAccessible() {
      if (this.steps[this.actualStep].isAffectingFollowingSteps) {
        this.isOverviewStepAccessible = false;
        for (let i = this.actualStep + 1; i < this.steps.length; i++) {
          if (this.steps[i].isAccessible) {
            this.steps[i].isAccessible = false;
            this.$store.commit("deleteSpecificStep", this.steps[i].id);
            this.$refs.stepListItems[i].resetTicks();
            this.$refs.stepListItems[i].resetDropdowns();
          }
        }
      }
    },
    setNextStepToAccessible() {
      this.steps[this.actualStep].isAccessible = true;
      // This setting is also changing the status of the buttons
      this.updateStepButtons();
    },
    updateStepButtons() {
      // Set the right button on disabled,
      // if the last step is the actual one or the next step is not accessible
      if (
        this.actualStep + 1 >= this.steps.length ||
        !this.steps[this.actualStep + 1].isAccessible
      )
        this.isRightButtonDisabled = true;
      else this.isRightButtonDisabled = false;

      if (
        this.actualStep + 1 >= this.steps.length &&
        this.showOverview &&
          !this.isOverviewStepVisible &&
          this.isOverviewStepAccessible
      ) {
        this.isRightButtonDisabled = false;
      }

      // Set the left button on disbled,
      // if the actual step is the first step
      if (this.actualStep - 1 < 0) this.isLeftButtonDisabled = true;
      else this.isLeftButtonDisabled = false;
    },
    roundToTwo(num) {
      // With Fixed(2) the rounding isn't correct 0.005 => 0.00
      // This function corrects this error
      return +(Math.round(num + "e+2") + "e-2");
    },
    setPrice(price) {
      this.priceFloat = price;
    },
    refreshPrice() {
      let price = this.priceFloat + this.productPricesSum;
      // this.priceFloat = this.roundToTwo(this.priceFloat);
      // if the productPrice is calculated set the calculated price
      if (price > 0.0) {
        this.isCalculatedPrice = true;
      } else {
        this.isCalculatedPrice = false;
      }
      this.setPriceText();
    },
    setPriceText() {
      let isPriceEstimated = false;
      if (this.mainComponent == null) {
        this.mainComponent = () =>
          import(`../customer/${this.p_configuratorDomain}/Main.vue`);
      } else {
        if (this.$refs.mainComponent != undefined) {
          this.$refs.mainComponent.checkIfPriceIsEstimated();
          isPriceEstimated = this.$refs.mainComponent.getIsPriceEstimated();
        }
      }

      this.priceText = this.isCalculatedPrice
        ? isPriceEstimated
          ? "Ab " + this.c_currency
          : " " + this.c_currency
        : "Ab " + this.c_basePriceCurrency;
    },
    setBasePrice(basePrice) {
      this.basePriceFloat = basePrice;
    },
    initializeHelpSettings() {
      // In the table configurator_settings
      // search for the following entries.
      // This entries are created with a new configurator.
      //
      // Please don't change the array indizes.
      this.p_configuratorSettings.forEach(setting => {
        if (setting.name == "Show Help") {
          this.showHelp = setting.value == "1";
        } else if (setting.name == "Help Contact") {
          this.helpSettings.splice(0, 0, setting);
        } else if (setting.name == "Help Phone Title") {
          this.helpSettings.splice(1, 0, setting);
        } else if (setting.name == "Help Phone Href") {
          this.helpSettings.splice(2, 0, setting);
        } else if (setting.name == "Help Mail Title") {
          this.helpSettings.splice(3, 0, setting);
        } else if (setting.name == "Help Mail Href") {
          this.helpSettings.splice(4, 0, setting);
        } else if (setting.name == "Show Overview") {
          this.showOverview = setting.value == "1";
        } else if (setting.name == "Overview Header") {
          this.overviewSettings.splice(0, 0, setting);
        } else if (setting.name == "Overview Shipping") {
          this.overviewSettings.splice(1, 0, setting);
        } else if (setting.name == "Overview Payment") {
          this.overviewSettings.splice(2, 0, setting);
        } else if (setting.name == "Overview Assembly") {
          this.overviewSettings.splice(3, 0, setting);
        } else if (setting.name == "Show Overview Print") {
          this.showOverviewPrint = setting.value == "1";
        } else if (setting.name == "Show Skip") {
          this.showSkipButton = setting.value == "1";
        } else if (setting.name == "Show PG Switch") {
          this.showPGButton = setting.value == "1";
        } else if (setting.name == "Base Price") {
          let basePrice = parseFloat(setting.value);
          this.basePriceSettingFloat = basePrice;
          this.setBasePrice(basePrice);
          this.refreshPrice();
        } else if (setting.name == "Configuration Name Required") {
          this.isConfigurationNameRequired = setting.value == "1";
        }
      });
    }
  },
  beforeMount() {
    this.getAllSteps();
  },
  mounted() {
    if (
      this.$route.query.code != "" &&
      this.$route.query.code != null &&
      this.$route.query.code != "null"
    ) {
      this.isGetConfiguratorCodeGiven = true;
      this.getConfiguratorCode = this.$route.query.code;
    }

    this.$root.$on("load-from-webmessage", code => {
      if (!this.isLoadSaveVisible) {
        this.$refs.loadSave.loadConfiguration(code);
        this.isLoadSaveVisible = true;
      }
    });
  },
  created() {}
};
</script>

<style language="css">
@import "../../scss/configurator/style.css";
</style>



// WEBPACK FOOTER //
// src/components/configurator/Configurator.vue